<template>
  <div v-if="markup" class="bk-blokkli-item-icon" v-html="markup" />
  <div v-else-if="bundle === 'from_library'" class="bk-blokkli-item-icon">
    <Icon name="reusable" />
  </div>
  <div v-else class="bk-blokkli-item-icon">
    <Icon name="question" />
  </div>
</template>

<script setup>
import { computed, useBlokkli } from "#imports";
import { Icon } from "#blokkli/components";
const props = defineProps({
  bundle: { type: String, required: false }
});
const { definitions } = useBlokkli();
const markup = computed(
  () => props.bundle ? definitions.getBlockIcon(props.bundle) : void 0
);
</script>

<script>
export default {
  name: "ItemIcon"
};
</script>
